import "@stoplight/elements/styles.min.css";
import "./App.css";

import React, { useEffect, useState } from "react";
import { API } from "@stoplight/elements";
import { axios } from "./util/axios";
import { AxiosResponse } from "axios";
const queryParams = new URLSearchParams(window.location.search);
if (queryParams.get("c")) {
  if (!axios.defaults.params) axios.defaults.params = {};
  axios.defaults.params["c"] = queryParams.get("c");
}

function isLocal() {
  return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
}

interface APIUserResponse {
  token: string;
}

function App() {
  const [specUrl, setSpecUrl] = useState("");
  const [spec, setSpec] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function authCheck() {
      try {
        await axios("/user");
        loadSpec();
      } catch (err) {
        window.location.href = `${window.location.origin}/login?redirect=${encodeURIComponent(window.location.href)}`;
      }
    }

    function loadSpec() {
      let groupName = queryParams.get("group");
      if (!groupName) {
        groupName = "api-public";
      }
      setSpecUrl(`${window.location.origin}/api/v3/api-docs?group=${groupName}`);
    }

    authCheck();
  }, []);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        let response = await axios(specUrl, { withCredentials: true });
        let schema = formatSchema(response.data);
        setSpec(schema);
        setLoading(false);
      } catch (err) {
        //On localhost the ports are all wonky, so this just causes an infinite loop
        if (!isLocal()) {
          window.location.href = window.location.origin + "/login";
        } else {
          alert("Error fetching API docs, please login to application");
        }
      }
    }

    async function loadApiUser() {
      try {
        let response: AxiosResponse<APIUserResponse> = await axios("/user/api");
        let token = response.data.token;
        //Preload their API token, value taken from here https://github.com/stoplightio/elements/blob/b54c988b154e76d3b65865afa7547764fdc16263/packages/elements-core/src/components/TryIt/Auth/authentication-utils.ts#L71
        localStorage.setItem("TryIt_securitySchemeValues", JSON.stringify({ monster: token }));
      } catch (err) {
        localStorage.setItem("TryIt_securitySchemeValues", JSON.stringify({ monster: "Create an API token to begin" }));
        console.log(`Error preloading API token: ${err}`);
      }
    }
    specUrl && load();
    specUrl && loadApiUser();
  }, [specUrl]);
  return (
    <div style={{ height: "100vh" }}>
      {loading ? (
        <div style={{ color: "gray", fontSize: "16px" }}>Loading...</div>
      ) : (
        <API
          // hideSchemas={true}
          hideExport={true}
          tryItCredentialsPolicy="omit"
          basePath="/api-docs"
          apiDescriptionDocument={spec}
        ></API>
      )}
    </div>
  );
}

//Our API docs right now return arrays wrapped in strings, convert them into Arrays for the examples to work
function formatSchema(swaggerSpec: any) {
  if (isLocal()) {
    swaggerSpec.servers[0].url = `http://${window.location.hostname}`;
  }
  for (let dtoName in swaggerSpec?.components?.schemas) {
    let dto = swaggerSpec?.components?.schemas[dtoName];
    for (let propertyName in dto.properties) {
      if (dto.properties[propertyName].example === "[]") {
        dto.properties[propertyName].example = [];
      } else if (dto.properties[propertyName].type === "array") {
        dto.properties[propertyName].example = [];
      }
    }
  }
  return swaggerSpec;
}

export default App;
